// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AdminBarActivator-cls1__ce1def872a62239cee36{/*!*/}.AdminBarActivator-cls2__ff82df62ca350e99b792{cursor:not-allowed;background-color:#333;opacity:.8}.AdminBarActivator-cls2__ff82df62ca350e99b792:hover{opacity:.8}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AdminBarActivator-cls1__ce1def872a62239cee36",
	"cls2": "AdminBarActivator-cls2__ff82df62ca350e99b792 AdminBarActivator-cls1__ce1def872a62239cee36"
};
export default ___CSS_LOADER_EXPORT___;
